import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnProtocolNavigationSimulationResult = new ThunderDispatcher('__onProtocolNavigationSimulation');
export const dispatch_OnExpressionCalculationResult = new ThunderDispatcher('__onExpressionCalculation');
//# sourceMappingURL=dispatchers.js.map